import Axios from "../api/axios";
import config from "../../config";

const getDsarLetter = () => {
  return Axios.get(`${config.BASE_URL}dsar-letter`);
};

export default getDsarLetter;
